import ExpandableList from "../common/ExpandableList";
import Task, {TaskForm} from "./Task";



export const TaskList = loadURL => ExpandableList(Task, TaskForm, loadURL, "task", "Seznam úloh", "Nová úloha", "Přidat úlohu",  ((a,b) => (a.name && a.name.localeCompare(b.name, undefined, {numeric: true, sensitivity: 'base'}))));

